import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefund.Find.IRequest;
type Response = Api.Sales.ContractRefund.Find.IResponse;
type Headers = Api.Sales.ContractRefund.Find.IHeaders;
const url = '/api/Sales/ContractRefund/:id';
export default async function contractRefundFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
